import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const SearchInput = ({ handleOnChange, query }) => {
	const { t } = useTranslation();
	return (
		<SearchInputStyled>
			<InputStyled
				name="query"
				type="text"
				autoFocus
				placeholder={t('common_header_nav_search_placeholder')}
				onChange={handleOnChange}
				value={query}
			/>
		</SearchInputStyled>
	);
};

const SearchInputStyled = styled.div`
	flex: 1;
	border-left: 1px solid ${({ theme }) => theme.dashedLine};
	padding-left: 1.5rem;
`;

const InputStyled = styled.input`
	width: 100%;
	border: 0;
	border-bottom: 1px solid ${({ theme }) => theme.line};
	padding: 0.7rem 1rem;
	color: ${({ theme }) => theme.grayMedium};
	font-size: 1.4rem;
	background-color: ${({ theme: { navSearch } }) => navSearch.inputBg};

	&:focus {
		outline: none;
		border-bottom: 1px solid ${({ theme }) => theme.primary};
	}

	&::placeholder {
		color: ${({ theme }) => theme.grayMedium};
		font-size: 1.4rem;
	}

	&:-webkit-autofill,
	&:-webkit-autofill:hover,
	&:-webkit-autofill:focus {
		-webkit-text-fill-color: ${({ theme }) => theme.grayMedium};
		-webkit-box-shadow: 0 0 0px 1000px
			${({ theme: { navSearch } }) => navSearch.inputBg} inset;
		transition: background-color 5000s ease-in-out 0s;
	}
`;

SearchInput.propTypes = {
	handleOnChange: PropTypes.func.isRequired,
	query: PropTypes.string.isRequired
};

export default SearchInput;
